function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".AddTriple-1{fill:none;stroke:#000;stroke-miterlimit:3.3;stroke-width:1.62px;}.AddTriple-2{fill:#37beb7;}"));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M24,15a9,9,0,0,0-3,.52V13H13v2H9V11h2V3H3v8H7V27h6v4h5.35A9,9,0,1,0,24,15Zm-8.94,8H13v2H9V17h4v4h2.52A9.54,9.54,0,0,0,15.06,23ZM24,30.88A6.89,6.89,0,1,1,30.88,24,6.9,6.9,0,0,1,24,30.88Z",
  transform: "translate(-0.19 -0.19)"
});

var _ref4 = /*#__PURE__*/React.createElement("polygon", {
  points: "24.81 22.81 24.81 18.81 22.81 18.81 22.81 22.81 18.81 22.81 18.81 24.81 22.81 24.81 22.81 28.81 24.81 28.81 24.81 24.81 28.81 24.81 28.81 22.81 24.81 22.81"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  id: "rect5254-8",
  className: "AddTriple-1",
  d: "M5,.81H30.59A4.22,4.22,0,0,1,34.81,5V30.6a4.21,4.21,0,0,1-4.21,4.21H5A4.22,4.22,0,0,1,.81,30.59V5A4.21,4.21,0,0,1,5,.81Z"
});

var _ref6 = /*#__PURE__*/React.createElement("rect", {
  className: "AddTriple-2",
  x: 2.81,
  y: 2.81,
  width: 8,
  height: 8
});

var SvgAddTriple = function SvgAddTriple(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "AddTriple",
    viewBox: "0 0 35.62 35.62",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAddTriple, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/AddTriple.d885b336.svg";
export { ForwardRef as ReactComponent };